import script from "./articleCommentStatusComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./articleCommentStatusComponent.vue?vue&type=script&setup=true&lang=js"

import "./articleCommentStatusComponent.vue?vue&type=style&index=0&id=9cdd8150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cdd8150"]])

export default __exports__